import Grid from "@mui/material/Grid";

import {QtyForMonthProvider} from "../../context/InventoryContext";
import InventoryHeader from "./InventoryHeader";
import InventoryDataGrid from "./InventoryDataGrid";
import {useEffect} from "react";
import {Button} from "antd";
import firebase from "firebase";

export default function InventoryView() {


        async function updateAllQuantityForMonth() {
            const db = firebase.firestore();
            const collectionRef = db.collection('items');
            let lastDoc = null;
            let done = false;
            let count = 0;

            console.log('Début de la vérification et mise à jour du champ "quantityForMonth" dans tous les documents de la collection "items".');

            while (!done) {
                const query = lastDoc ? collectionRef.startAfter(lastDoc) : collectionRef;
                const querySnapshot = await query.limit(500).get();

                const batch = db.batch();

                querySnapshot.forEach((doc) => {
                    const docRef = collectionRef.doc(doc.id);

                    // Vérifier si la valeur du champ est égale à 0 dans ce document
                    if (doc.exists && doc.data().QuatityForMonth === 0) {
                        // Mettre à jour la valeur du champ à 1 dans ce document
                        batch.set(docRef, { QuatityForMonth: 1 }, { merge: true });
                        count++;
                    }
                });

                // Écrire les modifications dans la base de données
                await batch.commit();

                console.log(`Nombre de documents traités : ${count}`);

                if (querySnapshot.size < 500) {
                    done = true;
                } else {
                    lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
                }
            }

            console.log(`Le champ 'quantityForMonth' a été mis à jour dans ${count} documents de la collection 'items'.`);
        }


    
    return (
        <QtyForMonthProvider>
            <Grid container spacing={4}>
                {/*<Grid item xs={12}>
                    <InventoryHeader/>
                </Grid>*/}
                <Button onClick={()=>updateAllQuantityForMonth()}>
                    Mise a jour des quantity for mouth
                </Button>

                <Grid item xs={12}>
                    <InventoryDataGrid/>
                </Grid>

            </Grid>
        </QtyForMonthProvider>
    )
}
